import { IncludeInSymptomMonitoringEmailPayload } from './IncludeInSymptomMonitoringEmailPayload';
import { ShowPortalSymptomNoticePayload } from './ShowPortalSymptomNoticePayload';

export enum ElaasConsequenceCode {
  SHOW_ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD = 'SHOW_ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD',
  DISMISS_PREVIOUS_ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD = 'DISMISS_PREVIOUS_ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD',
  TRIGGER_PULSE_OX_AT_REST_ON_DEMAND_REQUEST = 'TRIGGER_PULSE_OX_AT_REST_ON_DEMAND_REQUEST',
  TRIGGER_PULSE_OX_WALKING_ON_DEMAND_REQUEST = 'TRIGGER_PULSE_OX_WALKING_ON_DEMAND_REQUEST',
  SHOW_PORTAL_SYMPTOM_NOTICE = 'SHOW_PORTAL_SYMPTOM_NOTICE',
  SEND_SYMPTOM_NOTICE_EMAIL = 'SEND_SYMPTOM_NOTICE_EMAIL',
  INCLUDE_IN_SYMPTOM_MONITORING_EMAIL = 'INCLUDE_IN_SYMPTOM_MONITORING_EMAIL',
  UPDATE_PATIENT_CUSTOM_STATUS = 'UPDATE_PATIENT_CUSTOM_STATUS',
}

type Consequence<TConsequenceCode extends ElaasConsequenceCode, TVersionCode extends string, TPayload = undefined> = {
  consequenceCode: TConsequenceCode;
  versionCode: TVersionCode;
  // eslint-disable-next-line @typescript-eslint/ban-types
} & (TPayload extends undefined ? { payload?: TPayload } : { payload: TPayload });

export type ShowAssessmentConsequenceActivityCardV1 = Consequence<
  ElaasConsequenceCode.SHOW_ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD,
  '1',
  {
    cardCode: string;
  }
>;

export type DismissAssessmentConsequenceActivityCardV1 = Consequence<
  ElaasConsequenceCode.DISMISS_PREVIOUS_ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD,
  '1',
  {
    cardCode: string;
  }
>;

export type TriggerPulseOxAtRestOnDemandRequest = Consequence<
  ElaasConsequenceCode.TRIGGER_PULSE_OX_AT_REST_ON_DEMAND_REQUEST,
  '1'
>;

export type TriggerPulseOxWalkingOnDemandRequest = Consequence<
  ElaasConsequenceCode.TRIGGER_PULSE_OX_WALKING_ON_DEMAND_REQUEST,
  '1'
>;

export type ShowPortalSymptomNoticeV1 = Consequence<
  ElaasConsequenceCode.SHOW_PORTAL_SYMPTOM_NOTICE,
  '1',
  ShowPortalSymptomNoticePayload | undefined
>;

export type SendSymptomNoticeEmailV1 = Consequence<ElaasConsequenceCode.SEND_SYMPTOM_NOTICE_EMAIL, '1'>;

export type IncludeInSymptomMonitoringEmailV1 = Consequence<
  ElaasConsequenceCode.INCLUDE_IN_SYMPTOM_MONITORING_EMAIL,
  '1',
  IncludeInSymptomMonitoringEmailPayload | undefined
>;

type UpdatePatientCustomStatusPayload = {
  type: string;
  value: string;
};
export type UpdatePatientCustomStatusV1 = Consequence<
  ElaasConsequenceCode.UPDATE_PATIENT_CUSTOM_STATUS,
  '1',
  UpdatePatientCustomStatusPayload
>;

export type ElaasConsequenceConfig =
  | ShowAssessmentConsequenceActivityCardV1
  | DismissAssessmentConsequenceActivityCardV1
  | TriggerPulseOxAtRestOnDemandRequest
  | TriggerPulseOxWalkingOnDemandRequest
  | SendSymptomNoticeEmailV1
  | ShowPortalSymptomNoticeV1
  | IncludeInSymptomMonitoringEmailV1
  | UpdatePatientCustomStatusV1;
